import * as React from "react";
const SvgIconChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 407.437 407.437", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M376.258 81.567l-172.54 173.945L31.179 81.567 0 112.815 203.718 315.87l203.719-203.055z" }));
export default SvgIconChevronDown;
